import { useQuery } from 'react-query';

import { DataRoomDiligenceRequest, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useLenderDiligenceRequestsQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomDiligenceRequests.Lender(guid),
		() =>
			AxiosUtils.getResponseData<DataRoomDiligenceRequest[]>(
				api.get(CerebroApiEndpoints.DataRoomDiligenceRequests.Lender(guid))
			),
		{ enabled: guid !== undefined }
	);
}
